import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {Box, FormControl, FormHelperText} from "@mui/material";
import I18nHtmlEditor from "../../i18n-html-editor";
import {RENDERER_TYPES} from "../constants";
import {isFieldMultilang, pruneEmptyValues} from "../utils";

export const I18nHtmlEditorTester = schemaMatches(
  schema =>
    schema.renderer === RENDERER_TYPES.i18nHtmlEditor ||
    (schema.renderer === RENDERER_TYPES.htmlEditor && isFieldMultilang(schema))
);

export const I18nHtmlEditorRenderer = withJsonFormsControlProps(({data, handleChange, path, errors}) => {
  const isError = Boolean(errors && errors.length > 0);

  return (
    <FormControl fullWidth error={isError} className="custom-json-forms__renderers__i18n-html-editor">
      <Box
        sx={{
          border: theme => (isError ? `1px solid ${theme.palette.error.main} !important` : undefined)
        }}
      >
        <I18nHtmlEditor value={data} onChange={value => handleChange(path, pruneEmptyValues(value))} />
      </Box>
      {isError && (
        <FormHelperText error sx={{marginLeft: "14px"}}>
          {errors}
        </FormHelperText>
      )}
    </FormControl>
  );
});
